import axiosInstance from "./axios";

export const queryUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return response.data;
};
